"use client"
import { getTheme } from "@/theme"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { SxProps, Theme } from "@mui/material"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Typography from "@mui/material/Typography"
import { FC, PropsWithChildren } from "react"
import { GlowDivider } from "./GlowDivider"

interface Props extends PropsWithChildren {
    question: string
    id: string
    sx?: SxProps<Theme>
}

export const Question: FC<Props> = ({ question, children, id, sx }) => {
    const style = {
        ...styles.question,
        ...sx,
    }
    return (
        <>
            <Accordion sx={style} disableGutters>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={id}
                    id={id + "header"}
                >
                    <Typography component="h3" variant="h6" sx={styles.questionTitle}>
                        {question}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={styles.answerDetails}>{children}</AccordionDetails>
            </Accordion>
            <GlowDivider />
        </>
    )
}

const theme = getTheme()

const styles: Record<string, SxProps<Theme>> = {
    question: {
        mt: 4,
        width: { xs: "100%", md: "90%" },
        background: "transparent",
        boxShadow: "unset",
        border: "unset",
        "&.MuiAccordion-root": {
            "&:before": {
                background: "none",
            },
        },
    },

    questionTitle: {
        fontSize: {
            xs: theme.typography.subtitle1.fontSize,
            lg: theme.typography.h6.fontSize,
        },
        color: (theme) => theme.palette.text.primary,
        fontWeight: 600,
        width: "100%",
    },
    answerDetails: {
        pt: 0,
        color: (theme) => theme.palette.text.secondary,
    },
}
